// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-col.search-col {
  vertical-align: flex-end;
}

ion-col.search-col ion-button {
  padding: 0;
}

ion-col.search-col ion-button ion-icon, ion-col.search-col ion-button span {
  vertical-align: middle;
}

.box-shadow {
  padding: 4px;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
}

@media only screen and (max-width: 1024px) {
  .largeScreenFilter {
    display: none;
  }
  .littleScreenFilter {
    display: block;
  }
}
@media only screen and (min-width: 1024px) {
  .largeScreenFilter {
    display: block;
  }
  .littleScreenFilter {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/filter components/filter-bar/filter-bar.component.scss","webpack://./src/components/filter%20components/filter-bar/filter-bar.component.scss"],"names":[],"mappings":"AAAA;EACE,wBAAA;ACCF;;ADEA;EACE,UAAA;ACCF;;ADEA;EACE,sBAAA;ACCF;;ADEA;EACI,YAAA;EACA,iDAAA;ACCJ;;ADGC;EACC;IACI,aAAA;ECAJ;EDGA;IACI,cAAA;ECDJ;AACF;ADIA;EACA;IACE,cAAA;ECFA;EDKF;IACE,aAAA;ECHA;AACF","sourcesContent":["ion-col.search-col{\n  vertical-align: flex-end;\n}\n\nion-col.search-col ion-button{\n  padding:0;\n}\n\nion-col.search-col ion-button ion-icon, ion-col.search-col ion-button span{\n  vertical-align: middle;\n}\n\n.box-shadow {\n    padding: 4px;\n    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;\n  }\n\n// handle filter size on change screen width\n @media only screen and (max-width: 1024px) {\n  .largeScreenFilter {\n      display: none;\n  }\n\n  .littleScreenFilter {\n      display: block;\n  }\n}\n\n@media only screen and (min-width: 1024px) {\n.largeScreenFilter {\n  display: block;\n}\n\n.littleScreenFilter {\n  display: none;\n  }\n}","ion-col.search-col {\n  vertical-align: flex-end;\n}\n\nion-col.search-col ion-button {\n  padding: 0;\n}\n\nion-col.search-col ion-button ion-icon, ion-col.search-col ion-button span {\n  vertical-align: middle;\n}\n\n.box-shadow {\n  padding: 4px;\n  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;\n}\n\n@media only screen and (max-width: 1024px) {\n  .largeScreenFilter {\n    display: none;\n  }\n  .littleScreenFilter {\n    display: block;\n  }\n}\n@media only screen and (min-width: 1024px) {\n  .largeScreenFilter {\n    display: block;\n  }\n  .littleScreenFilter {\n    display: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
